<p class="text-title-lgx-bold">Dirección</p>
<p class="text-info-bold-xs mt-xxs mb-xs">¿DÓNDE PUEDEN LLEGAR TUS PACIENTES?</p>
<nz-alert nzType="info"
  class="tw-w-full"
  nzMessage="Estos datos están protegidos bajo estándares de manejo de la información." nzShowIcon></nz-alert>
<div class="mt-sm tw-w-full">
  <app-address-section [removeClassCardContainerShadow]="true" [showHeader]="false" [rowsReference]="1" [cssLabelClass]="'text-info-upper mb-xs'"></app-address-section>
</div>
